const process = e => {

	e.preventDefault()

	let data = new FormData(e.target)

	let values = []

	data.values().forEach((value, i) => {
		values[i] = value
	})

	let mailto = 'mailto:info@dv8-designs.co.uk',
		subject = '?subject=DV8 Enquiry',
		body = '&body=Message:%0A%0AName: ' + values[0]

	if (values[1]) body += '%0A%0AEmail Address: ' + values[1]

	if (values[2]) body += '%0A%0ACompany: ' + values[2]

	window.location.href = mailto + subject + body

	e.target.innerHTML = '<div class="success">Thank you for your enquiry, we\'ll be in touch shortly</div>';

}

export const forms = () => {

	let forms = document.querySelectorAll('[data-process]')

	forms.forEach(form => {
		form.addEventListener('submit', process, false)
	})

}

export default () => { }